import controller from './class-designer-node-editor.controller';
import template from './class-designer-node-editor.html';
import './class-designer-node-editor.scss';

export default {
	controller,
	template,
	bindings: {
		disabled: '<?ngDisabled',
		selected: '<ngModel',
	},
	require: {
		editor: '^^classDesignerEditor',
	},
};
